<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>Careers | Platforma</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Start a life changing journey right now at Platforma"
      />
    </Head>
  </div>
  <!-- content start -->

  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
  >
    <!-- ===================== HERO SECTION ===================== -->

    <section
      id="section1"
      class="hero-section relative mx-auto mt-[150px] mb-[50px] gap-1 bg-transparent lg:flex lg:py-0"
      :style="backgroundImageStyleMain"
    >
      <div class="mt-0 bg-transparent px-[25px] xl:px-0">
        <h1
          class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Change your life<br />
          with Platforma.
        </h1>

        <p
          class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
        >
          A great workplace combines exceptional people<br />
          with challenging problems.
        </p>

        <div class="left-0 mx-auto flex flex-col">
          <a href="#jobOpening">
            <button
              class="my-[25px] h-[50px] w-[148px] rounded-[4px] bg-[#2d8bff] text-[14px] font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
            >
              Apply Now
            </button>
          </a>
        </div>
      </div>

      <div class="mb-[30px] mt-[30px] lg:mt-0 z-10">
        <video
          class="home-hero-video xl:absolute xl:w-[900px] xl:translate-x-[0%] xl:-translate-y-[5%] aspect-auto"
          id="home_video"
          loop
          muted
          autoplay
          playsinline
        >
          <source
            :src="$filters.media_path('/videos/home_video.webm')"
            type="video/webm"
          />
        </video>
      </div>
    </section>
  </div>
  <!-- =======CONTAINER END======== -->

  <!-- ===================== MISSION SECTION===================== -->
  <section
    class="mt-[50px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[200px] lg:flex lg:h-[600px] xl:px-0"
  >
    <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
      <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
        <div id="text_mission" class="text-xs font-extrabold text-[#2D8CFF]">
          MISSION
        </div>

        <h2
          class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Our Mission.
        </h2>

        <hr
          class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
        />

        <p
          class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
        >
          While we absolutely love marketing software, we believe content
          distribution, in general, is broken. There's just too many tools to
          keep track of, too much censorship and not enough money flowing to
          where it should. There has to be a better way to monetize content -
          that's why we created Platforma, first an internal tool, now as a way
          to fulfill our vision of giving power back to the creator.<br />
          <br />
          Eventually, our goal is to have all members live in Platforma -
          thereby giving the internet back to the people. Protect and Monetize
          Your Content. We're just getting started, and are so grateful for all
          of the 10,000+ entrepreneurs that are in this together with our team.
        </p>
      </div>

      <div class="z-30 mt-[25px] xl:mt-0">
        <img
          loading="lazy"
          class="lg:w-[675px]"
          :src="
            $filters.media_path(
              '/images/platforma-membership-sites-mission-hero.svg'
            )
          "
          alt="Host all your company training courses in one place."
        />
      </div>
    </div>
  </section>

  <!-- ===================== WHO SHOULD WORK WITH US ===================== -->
  <section
    class="mt-[50px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[150px] lg:flex lg:h-[600px] xl:px-0 lg:flex-row-reverse"
  >
    <div
      class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
    >
      <div
        id="text_who"
        class="text-xs font-extrabold text-[#27AE60] lg:left-0"
      >
        WHO
      </div>

      <h2
        class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Who should work at Platforma?
      </h2>

      <div class="">
        <hr
          class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
        />
      </div>

      <p
        class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
      >
        Platforma was founded on a culture of hard work, consistent growth, and
        a desire to break norms. We’re a values-driven company and hire based on
        ambition, merit, and a willingness to do what it takes to succeed. We
        don’t care where you’re from, what you look like—we hire the best people
        for the job, and create an environment that supports employees on their
        journey to do the most exciting work of their lives!
        <br /><br />
        Platforma is an Equal Opportunity Employer, and qualified applicants
        will receive consideration for employment without regard to race, color,
        religion, sex, sexual orientation, gender identity, or national origin.
      </p>
    </div>

    <div class="mt-[25px] xl:mt-0">
      <img
        loading="lazy"
        class="lg:max-w-[675px]"
        :src="$filters.media_path('/images/work-maxims.svg')"
        alt="Host all your company training courses in one place."
      />
    </div>
  </section>

  <section
    class="mx-auto mt-[70px] max-w-[1200px] px-[25px] lg:mt-[150px] xl:px-0 text-center"
  >
    <div class="mt-12 py-0">
      <h4
        id="text_member_activity"
        class="text-xs font-extrabold text-[#2D8CFF]"
      >
        VACANCIES
      </h4>

      <h2
        class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Be Part of Something Great
      </h2>
      <p
        class="mt-[20px] text-sm font-medium leading-[25px] text-[#7c828d] text-center"
      >
        Love your work. Join your dream team.
      </p>
    </div>
    <h2
      class="top-full mt-[100px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
    >
      Platforma
    </h2>
    <p
      class="mt-[20px] text-sm font-medium leading-[25px] text-[#7c828d] text-center"
    >
      Current Job Openings
    </p>
  </section>

  <!-- =============EMPLOYEMENT OPP SECTION=============== -->

  <section class="max-w-[1140px] mx-auto mt-[50px]" id="jobOpening">
    <div
      class="rounded-xl shadow-xl px-[30px] py-[11px] bg-gradient-to-b from-[#2d8bff91] to-[#2d8bff] max-w-[307px] hover:shadow-md hover:mt-[20px] ml-[10px]"
    >
      <h3 class="text-center text-white font-bold text-[40px]">Engineering</h3>
    </div>
    <div
      class="rounded-xl shadow-xl mt-[45px] ml-[20px] px-[30px] py-[11px] bg-gradient-to-b from-[#49CCF991] to-[#49CCF9] max-w-[331px]"
    >
      <h3 class="text-center text-white font-bold text-[40px]">Core Product</h3>
    </div>
    <Link href="/careers-backend-dev">
      <div
        class="max-w-[910px] shadow-xl bg-white py-5 px-[25px] mt-[30px] ml-[20px] rounded-xl justify-between flex hover:shadow-md cursor-pointer transition delay-100 duration-500 ease-in-out hover:scale-[102%] hover:underline"
        href="https://platformarea.com/careers-backend-dev.com"
      >
        <h4 class="font-semibold text-lg text-[#292d34]">
          Principal Backend Engineer
        </h4>
        <h4 class="font-base text-lg text-[#292d34]">Vietnam</h4>
      </div>
    </Link>
    <Link href="/careers-qa">
      <div
        class="max-w-[910px] shadow-xl bg-white py-5 px-[25px] mt-[30px] ml-[20px] rounded-xl justify-between flex hover:shadow-md cursor-pointer transition delay-100 duration-500 ease-in-out hover:scale-[102%] hover:underline"
        href="https://platformarea.com/careers-qa.com"
      >
        <h4 class="font-semibold text-lg text-[#292d34]">
          Quality Assurance/Testing Value Engineer
        </h4>
        <h4 class="font-base text-lg text-[#292d34]">Vietnam</h4>
      </div>
    </Link>

    <section class="max-w-[1140px] mx-auto mt-[50px] px-[10px]">
      <div
        class="rounded-xl shadow-xl px-[30px] py-[11px] bg-gradient-to-b from-[#2d8bff91] to-[#2d8bff] max-w-[307px]"
      >
        <h3 class="text-center text-white font-bold text-[40px]">Design</h3>
      </div>
      <div
        class="rounded-xl shadow-xl mt-[45px] ml-[20px] px-[30px] py-[11px] bg-gradient-to-b from-[#49CCF991] to-[#49CCF9] max-w-[331px]"
      >
        <h3 class="text-center text-white font-bold text-[40px]">
          Core Product
        </h3>
      </div>
      <Link href="/careers-designer">
        <div
          class="max-w-[910px] shadow-xl bg-white py-5 px-[25px] mt-[30px] ml-[20px] rounded-xl justify-between flex hover:shadow-md cursor-pointer transition delay-100 duration-500 ease-in-out hover:scale-[102%] hover:underline"
          href="https://platformarea.com/careers-designer.com"
        >
          <h4 class="font-semibold text-lg text-[#292d34]">
            UI/UX Principal Designer
          </h4>
          <h4 class="font-base text-lg text-[#292d34]">United States</h4>
        </div>
      </Link>
    </section>

    <!-- ===================== PERKS AND BENEFITS SECTION===================== -->
    <section
      class="mx-auto max-w-[1200px] px-[25px] mt-[125px] lg:h-[500px] xl:px-0"
    >
      <div class="mt-12 py-0">
        <h4
          id="text_member_activity"
          class="text-xs font-extrabold text-[#2D8CFF]"
        >
          PERKS AND BENEFITS
        </h4>

        <h2
          class="top-full mt-[20px] mb-[100px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Platforma Perks and Benefits.
        </h2>
      </div>

      <div class="mt-[45px] w-full flex-wrap justify-between md:flex">
        <div class="flex md:w-[50%]">
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-macbook-blue.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
              16" MacBook Pro.
            </h4>
          </div>
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-utensils-yellow.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4
              class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]"
            >
              Team lunches each week.
            </h4>
          </div>
        </div>

        <div class="mt-10 flex md:mt-0 md:w-[50%]">
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-teal2-umbrella.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
              Flexible PTO
            </h4>
          </div>
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-truck-red.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
              Moving Expenses
            </h4>
          </div>
        </div>
      </div>

      <div class="mt-[45px] w-full flex-wrap justify-between md:flex">
        <div class="flex md:w-[50%]">
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-drinks-green.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4
              class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]"
            >
              Unlimited snacks, kombucha, and cold brew.
            </h4>
          </div>
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-swag-teal.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4 class="mt-[15px] flex text-lg font-medium text-[#292d34]">
              Platforma Swag
            </h4>
          </div>
        </div>

        <div class="mt-10 flex md:mt-0 md:w-[50%]">
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-bus-pink.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4
              class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]"
            >
              $200/mo commuter benefits
            </h4>
          </div>
          <div class="w-[50%]">
            <img
              :src="$filters.media_path('/images/perks-present-purple.svg')"
              alt=""
              class="rounded-[20px] shadow-xl"
            />
            <h4
              class="mt-[15px] flex w-[75%] text-lg font-medium text-[#292d34]"
            >
              Teammate recognition rewards.
            </h4>
          </div>
        </div>
      </div>
    </section>
  </section>
  <!-- ===================== CTA BLOCK ===================== -->
  <CtaBlock cta-headline="We're here to help." />
</template>

<!-- CONTENT END -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import CtaBlock from '../Components/ProtectCtaBlockFooter.vue';

export default {
  layout: DefaultLayout,
  components: {
    ButtonComponent,
    EmailCaptureHeaderWidget,
    CtaBlock
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}
</style>
